export namespace LocaleModuleTest {

	export class Configurator implements Persistance {
		activateAllLocales: boolean;

		constructor(persistance?: Persistance) {
			this.activateAllLocales = persistance?.activateAllLocales ?? false;
		}
		
	}

	export interface Persistance {
		activateAllLocales: boolean;
	}
}